module.exports = __webpack_public_path__ + "img/moedas-do-dolar.1b0d4c3b.svg";